<app-contact-support-icon
  [sageUserName]="sageUserName$ | async"
  [currentClient]="currentClient$ | async"
  [currentYear]="currentYear$ | async"
  [currentProgram]="currentProgram$ | async"
  [allUsers]="allUsers$ | async"
  [userEmailListSelector]="userEmailListSelector$ | async"
></app-contact-support-icon>
